(function () {
  var ck = (window.ck = window.ck || { pages: {}, assets: {} });
  var html = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var loading = {};
  var active = [];
  var token = 0;
  var hardNavigating = false;

  var PAGE_MODULES = [
    { key: 'fx', selector: 'body' },
    { key: 'booking', selector: '[data-ck-trip-booking-config]' },
    { key: 'tripsFilter', selector: '[data-trips-filter]' },
    { key: 'heroShader', selector: '[data-ck-hero-shader]', idle: true },
    { key: 'header', selector: '[data-ck-header]' },
    { key: 'faq', selector: '[data-ck-faq]' },
    { key: 'calendar', selector: '[data-ck-calendar]' },
    { key: 'compareTray', selector: 'body' },
    { key: 'compare', selector: '[data-ck-compare]' },
    { key: 'packingList', selector: '[data-ck-packing]' },
    { key: 'home', selector: '[data-ck-motion]' },
    { key: 'concierge', selector: '[data-ck-concierge]' },
    { key: 'finder', selector: '[data-ck-finder]' },
    { key: 'journey', selector: '[data-ck-journey]' },
    { key: 'routeVisual', selector: '[data-ck-route-visual]' },
    { key: 'ambient', selector: '[data-ck-ambient], [data-ck-draw]' },
    { key: 'deep', selector: '[data-ck-walk], [data-ck-versus], [data-ck-enquiry]' }
  ];

  var SWUP_SKIP = /^\/(cart|checkout|checkouts|account|search|password|challenge|orders|apps|admin|policies|services|gift_cards|a)(\/|\?|#|$)/;

  ck.load = function (key) {
    if (loading[key]) return loading[key];
    loading[key] = new Promise(function (resolve, reject) {
      if (ck.pages[key] || (key === 'scrolltrigger' && window.ScrollTrigger) || !ck.assets[key]) {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = ck.assets[key];
      script.async = true;
      script.onload = resolve;
      script.onerror = function () {
        delete loading[key];
        reject(new Error('charkadam: failed to load ' + key));
      };
      document.head.appendChild(script);
    });
    return loading[key];
  };

  // Loads ScrollTrigger once and keeps it in step with Lenis's scroll position. Lenis scrolls the
  // real window, so ScrollTrigger.update on Lenis's scroll event is the supported wiring (a
  // scrollerProxy is only needed when Lenis wraps a custom scroll element).
  ck.scrollReady = function () {
    return ck.load('scrolltrigger').then(function () {
      if (!ck.stBound && window.gsap && window.ScrollTrigger) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        if (window.ckLenis) {
          window.ckLenis.on('scroll', window.ScrollTrigger.update);
          // Pin spacers change the page height; Lenis caches it, so re-measure after every refresh
          // or wheel scrolling stops short of the real bottom.
          window.ScrollTrigger.addEventListener('refresh', function () {
            window.ckLenis.resize();
          });
        }
        ck.stBound = true;
      }
      return window.ScrollTrigger;
    });
  };

  // Standard gating for every scroll effect: heavy work only >=990px with motion allowed.
  // handler receives { desktop, mobile, reduce }; return a cleanup function if needed.
  ck.matchMedia = function (handler) {
    var mm = window.gsap.matchMedia();
    mm.add(
      {
        desktop: '(min-width: 990px) and (prefers-reduced-motion: no-preference)',
        mobile: '(max-width: 989px) and (prefers-reduced-motion: no-preference)',
        reduce: '(prefers-reduced-motion: reduce)'
      },
      function (context) {
        return handler(context.conditions);
      }
    );
    return mm;
  };

  function whenIdle(fn) {
    var run = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
      else setTimeout(fn, 300);
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  function destroyPage() {
    token += 1;
    active.forEach(function (key) {
      var mod = ck.pages[key];
      if (mod && mod.destroy) {
        try {
          mod.destroy();
        } catch (e) {
          if (window.console) console.warn(e);
        }
      }
    });
    active = [];
  }

  function initPage() {
    destroyPage();
    var mine = token;
    // Keep the server's "this page opens on a green hero" hint true after Swup swaps the content (chrome.css).
    document.body.classList.toggle('ck-hero-first', !!document.querySelector('main > .shopify-section:first-child :is(.ck-hero, .ck-page-hero, .ck-thead, .ck-trip-hero, .ck-finder--page)'));

    PAGE_MODULES.forEach(function (m) {
      if (!document.querySelector(m.selector)) return;

      var run = function () {
        if (mine !== token) return;
        ck.load(m.key)
          .then(function () {
            var mod = ck.pages[m.key];
            if (mine !== token || !mod) return;
            mod.init();
            active.push(m.key);
          })
          .catch(function (e) {
            if (window.console) console.warn(e);
          });
      };

      if (m.idle) whenIdle(run);
      else run();
    });
  }

  function dispatchPageView() {
    if (!window.StandardEvents) return;
    var main = document.querySelector('main[data-template]');
    document.dispatchEvent(
      new window.StandardEvents.PageViewEvent({
        page: {
          template: (main && main.dataset.template) || '',
          title: document.title,
          url: window.location.href
        }
      })
    );
  }

  // Pin spacers appear after a page's modules initialise, so a plain hash jump (e.g. /#ck-find-your-trip
  // from another page) lands short. Re-aim once layout has settled.
  function scrollToHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (e) {
      return;
    }

    var go = function () {
      var el = document.getElementById(id);
      if (!el) return;
      if (Math.abs(el.getBoundingClientRect().top) < 40) return;
      if (window.ckLenis) window.ckLenis.scrollTo(el, { immediate: true, force: true });
      else el.scrollIntoView();
    };

    if (document.querySelector('[data-ck-motion]')) {
      ck.scrollReady().then(function () {
        window.setTimeout(go, 600);
      });
    } else {
      go();
    }
  }

  function stylesheetsReady() {
    var pending = Array.prototype.slice
      .call(document.querySelectorAll('#MainContent link[rel="stylesheet"]'))
      .filter(function (link) {
        return !link.sheet;
      });
    if (!pending.length) return null;

    var loaded = Promise.all(
      pending.map(function (link) {
        return new Promise(function (resolve) {
          link.addEventListener('load', resolve, { once: true });
          link.addEventListener('error', resolve, { once: true });
        });
      })
    );
    var timeout = new Promise(function (resolve) {
      setTimeout(resolve, 2500);
    });
    return Promise.race([loaded, timeout]);
  }

  function setupSwup() {
    if (!window.Swup) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var swup = new window.Swup({
      containers: ['#MainContent'],
      animationSelector: reduceMotion.matches ? false : '[class*="transition-"]',
      ignoreVisit: function (url, ctx) {
        var el = ctx && ctx.el;
        if (el && el.closest('[data-no-swup]')) return true;
        if (el && (el.getAttribute('href') || '').charAt(0) === '#') return true;
        return SWUP_SKIP.test(url);
      }
    });

    swup.hooks.before('content:replace', function (visit, args) {
      destroyPage();
      try {
        var doc = new DOMParser().parseFromString(args.page.html, 'text/html');
        var scripts = doc.querySelectorAll('#MainContent script[src]');
        for (var i = 0; i < scripts.length; i += 1) {
          var src = scripts[i].getAttribute('src');
          if (!document.querySelector('script[src="' + src + '"]')) {
            hardNavigating = true;
            window.location.href = visit.to.url;
            return;
          }
        }
      } catch (e) {
        if (window.console) console.warn(e);
      }
    });

    swup.hooks.on('content:replace', stylesheetsReady);

    swup.hooks.replace('scroll:anchor', function (visit, args, defaultHandler) {
      var el = null;
      try {
        el = document.getElementById(decodeURIComponent(String(args.hash).replace(/^#/, '')));
      } catch (e) {}
      if (el && window.ckLenis) {
        window.ckLenis.scrollTo(el);
        return true;
      }
      return defaultHandler(visit, args);
    });

    swup.hooks.replace('scroll:top', function (visit, args, defaultHandler) {
      if (window.ckLenis) {
        window.ckLenis.scrollTo(0, { immediate: true, force: true });
        return true;
      }
      return defaultHandler(visit, args);
    });

    swup.hooks.on('page:view', function () {
      if (hardNavigating) return;
      if (window.ckLenis) window.ckLenis.resize();
      initPage();
      scrollToHash();
      if (window.ScrollTrigger) window.setTimeout(window.ScrollTrigger.refresh, 300);
      dispatchPageView();
    });

    ck.swup = swup;
  }

  function start() {
    if (!window.gsap || !window.SplitText) html.classList.add('ck-motion-failed');
    initPage();
    setupSwup();
    scrollToHash();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', initPage);
  document.addEventListener('shopify:section:unload', destroyPage);
})();
